import React from 'react';
import { StyledWritingSection, StyledProformaSectionHeader, StyledTextArea, StyledTextAreaWrapper } from '../Styled';
import { Tooltip } from '../Tooltip';

interface IWritingProformaSection {
  lines: number;
  titleColor: string;
  mainColor: string;
  headerTitle: string;
  id: string;
  value: string;
  helpText: string;
  handleChange: (id: string, value: string, lines: number) => void;
  onFocus: (id: string) => void;
}

export const WritingProformaSection: React.FC<IWritingProformaSection> = props => {
  const { helpText, lines, titleColor, mainColor, headerTitle, value, handleChange, id, onFocus } = props;
  const textAreaHeight = 48 * lines;

  return (
    <StyledWritingSection data-testid="writing-proforma-section">
      <StyledProformaSectionHeader data-testid="proforma-header" bGColor={titleColor}>
        {headerTitle}
        <Tooltip helpText={helpText} />
      </StyledProformaSectionHeader>
      <StyledTextAreaWrapper data-testid="proforma-textarea-wrapper" bGColor={mainColor}>
        <StyledTextArea
          data-testid="proforma-textarea"
          onChange={event => handleChange(id, event.target.value, lines)}
          value={value.slice(0, textAreaHeight)}
          maxLength={textAreaHeight}
          rows={lines}
          onFocus={() => onFocus(id)}
        />
      </StyledTextAreaWrapper>
    </StyledWritingSection>
  );
};
